import Nullstack from 'nullstack';
export default function IconCherry({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cherry",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "7.5",
    cy: "16.5",
    r: "3.5"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "18",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M9 13c.366 -2.006 1.866 -3.873 4.5 -5.6"
  }), "   ", Nullstack.element("path", {
    d: "M17 15c-1.333 -2.333 -2.333 -5.333 -1 -9"
  }), "   ", Nullstack.element("path", {
    d: "M5 6c3.667 -2.667 7.333 -2.667 11 0c-3.667 2.667 -7.333 2.667 -11 0"
  }), " ");
}